import * as React from "react"

import { cva } from "./cva.ts"

export const CircleButton = React.forwardRef<CircleButton.Element, CircleButton.Props>(
  ({ className, ...props }, ref) => (
    <button
      data-ui="CircleButton"
      type="button"
      className={classForCircleButton({ className })}
      ref={ref}
      {...props}
    />
  ),
)

export namespace CircleButton {
  export type Element = HTMLButtonElement
  export type Props = React.ComponentProps<"button">
}

export const classForCircleButton = cva([
  "flex size-11 rounded-full",
  "items-center justify-center text-white",
  "bg-[color-mix(in_srgb,var(--foreground)_13%,transparent)]",
  "backdrop-blur-md",
  "[&>svg]:[filter:drop-shadow(0px_0px_4px_rgba(0,0,0,0.20))]",

  // &:disabled
  "disabled:opacity-50",
])
